module.exports = __webpack_public_path__ + "science.speed-and-friction.jpg?b786b7a2155c44e5d7c6f02bf0d4a192";